/**
 * Fonte única de verdade dos motivos e ações do ajuste manual de estoque
 * (botão "Atualizar Estoque" — PUT /foodz/api/v1/estoque/ajusteManual).
 *
 * IMPORTANTE — mantenha em sincronia com o backend:
 * os `code`/`value` abaixo precisam bater exatamente com o enum
 * `StockAdjustmentReason` (Java) e com os literais "UPDATE"/"REMOVE"/"RETURN"
 * aceitos pelo endpoint. O backend não expõe (ainda) uma rota GET para
 * servir essa lista, então ela é replicada aqui de propósito — mas em UM
 * único lugar do frontend. Se um endpoint de listagem for criado no futuro,
 * troque apenas este arquivo para consumi-lo.
 *
 * Lista de motivos validada por Matheus (dono do produto) em 2026-07-25.
 * Para ajustar rótulos, adicionar ou remover motivos, edite SOMENTE este
 * arquivo (e o enum espelhado no backend, em StockAdjustmentReason.java).
 */

// Único motivo que exige texto livre obrigatório (reasonText) junto do código.
export const OTHER_REASON_CODE = "OUTRO";

export const STOCK_ADJUSTMENT_REASONS = [
    { code: "PURCHASE", label: "Compras" },
    { code: "INVENTORY_COUNT_MISMATCH", label: "Contagem física divergente / correção de inventário" },
    { code: "DAMAGED_OR_EXPIRED", label: "Produto danificado ou vencido" },
    { code: "PREVIOUS_ENTRY_ERROR", label: "Erro de lançamento anterior" },
    { code: "INTERNAL_USE_OR_DONATION", label: "Doação / uso interno (não vendido)" },
    { code: OTHER_REASON_CODE, label: "Outro..." },
];

// As 2 ações expostas pelo botão "Atualizar Estoque". O endpoint /ajusteManual
// também aceita "UPDATE" (definir quantidade), mas essa ação não é exposta
// neste modal — permanece reservada ao fluxo interno de updateProduct.
export const STOCK_ADJUSTMENT_ACTIONS = [
    { value: "RETURN", label: "Adicionar Quantidade" },
    { value: "REMOVE", label: "Remover Quantidade" },
];
